import { queryKeys } from "@/api/queryKeys";
import { supabase } from "@/api/supabaseClient";
import { useAuth } from "@/auth/AuthContext";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect, useRef } from "react";

/**
 * Aktiviert eingeladene Mitgliedschaften des angemeldeten Users (RPC activate_my_memberships).
 * Einloggen = Einladung annehmen. Läuft einmal pro Session/User im App-Layout.
 */
export function MembershipActivationTrigger() {
  const { user } = useAuth();
  const queryClient = useQueryClient();
  const doneForUserRef = useRef<string | null>(null);

  useEffect(() => {
    const userId = user?.id;
    if (!userId || doneForUserRef.current === userId) return;
    doneForUserRef.current = userId;

    supabase
      .rpc("activate_my_memberships")
      .then(({ data, error }) => {
        if (error) {
          console.error("MembershipActivationTrigger failed", error.message);
          doneForUserRef.current = null;
          return;
        }
        const activated = typeof data === "number" ? data : 0;
        if (activated > 0) {
          queryClient.invalidateQueries({
            queryKey: queryKeys.organizations.my(userId),
          });
          queryClient.invalidateQueries({ queryKey: queryKeys.tenants.my });
        }
      });
  }, [user?.id, queryClient]);

  return null;
}
